import { render, staticRenderFns } from "./IncidentTypesTags.vue?vue&type=template&id=2b051522&scoped=true&"
import script from "./IncidentTypesTags.vue?vue&type=script&lang=js&"
export * from "./IncidentTypesTags.vue?vue&type=script&lang=js&"
import style0 from "./IncidentTypesTags.vue?vue&type=style&index=0&id=2b051522&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b051522",
  null
  
)

export default component.exports